import { P } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledNewsIcon, StyledTile, StyledTitle } from './NoDetails.styles';

export interface NoDetailsProps { }

const NoDetails: FC<NoDetailsProps> = () => {
  const { t } = useTranslation('NewsDetailsPage');
  return (
    <StyledTile data-testid="NewsDetailsNoDetails" isDivided={false}>
      <StyledNewsIcon />
      <StyledTitle>{t('noDetailsTitle')}</StyledTitle>
      <P>{t('noDetailsText')}</P>
    </StyledTile>
  );
};
export default (NoDetails);
